import { URLParam } from "@/helpers/interfaces/URLParam.ts";
import { useEngineStore } from "@/stores/EngineStore/EngineStore.ts";
import { useEffect } from "react";

export const useAccommodationTypeURLParams = () => {
  const setAccommodationTypeId = useEngineStore((state) => state.setAccommodationTypeId);

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const accommodationTypeParam = urlParams.get(URLParam.AccommodationType);

    if (accommodationTypeParam) setAccommodationTypeId(accommodationTypeParam);
    else setAccommodationTypeId(undefined);

    // eslint-disable-next-line
  }, []);
};
